import { useEffect } from 'react'
import { connect } from 'react-redux'

// Actions
import { actions as artistsActions } from 'modules/artists/actions'

// Components
import { Layout, PageHeading } from '@tracklib/kit'
import SEO from 'components/base/seo'
import ArtistsList from 'components/artistslist'
import { ArtistsFilter } from 'components/filter'
import LoadMoreButton from 'components/base/loadmorebutton'

// Selectors
import { selectRequest } from 'modules/requests/selectors'

// Types
import { ApiRequest, QueryResult, Dispatch, GetState, Artist, State } from 'types'

export const loadInitialData = () => async (dispatch: Dispatch, getState: GetState) => {
  const searchString = getState().router.location.search
  return dispatch(artistsActions.fetchArtists(searchString))
}

type ArtistsProps = {
  // mapStateToProps
  artists: Array<Artist>
  fetchArtistsRequest: ApiRequest
  searchString: string
  searchInfo: QueryResult
  // mapDispatchToProps
  fetchArtists: (searchString: string, page?: number) => void
}

const Artists = ({ artists, fetchArtists, fetchArtistsRequest, searchString, searchInfo }: ArtistsProps): JSX.Element => {
  useEffect(() => {
    if (!fetchArtistsRequest.isLoading && !fetchArtistsRequest.hasError && artists.length === 0) {
      fetchArtists(searchString)
    }
  }, [searchString]) // eslint-disable-line

  const showLoadMoreButton = artists.length > 0 && artists.length < searchInfo.count
  return (
    <>
      <SEO title="Artists | Tracklib" />
      <PageHeading heading="Artists" description="Dig through our diverse collection of artists from all genres." />
      <Layout.FullWidth>
        <ArtistsFilter />
      </Layout.FullWidth>
      <ArtistsList artists={artists} fetchArtistsRequest={fetchArtistsRequest} />
      {showLoadMoreButton && (
        <LoadMoreButton
          disabled={fetchArtistsRequest.isLoading}
          onClick={() => fetchArtists(searchString, searchInfo.lastPageLoaded + 1)}
          datatesting="button_artists_load_more"
        >
          Load more artists
        </LoadMoreButton>
      )}
    </>
  )
}

const mapStateToProps = (state: State) => {
  const searchString = state.router.location.search
  const searchInfo = state.artistsSearch[searchString || 'default']
  const allArtists = state.entities.artists
  return {
    artists: searchInfo ? searchInfo.ids.map(id => allArtists[String(id)]) : [],
    fetchArtistInfoRequest: selectRequest(state, 'FETCH_ARTIST_INFO', 'statik-link'),
    fetchArtistsRequest: selectRequest(state, 'FETCH_ARTISTS', searchString),
    searchString,
    searchInfo,
  }
}

const mapDispatchToProps = {
  fetchArtists: artistsActions.fetchArtists,
}

export { Artists as Component }
export default connect(mapStateToProps, mapDispatchToProps)(Artists)
